import * as actionType from "../actions/actionType";

const initialState = {
  tableList: [],
  page: 1,
  pageSize: 10,
  loading: false,
  editLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.ORDER_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };
    default:
      return state;
  }
};
